import InfiniteScroll from 'react-infinite-scroll-component'
import { useEffect } from 'react'

import Header from 'app/DocumentCollectionPage/components/Header'
import TitleSection from 'app/DocumentCollectionPage/components/TitleSection'
import {
  DEFAULT_CATEGORY_TITLE,
  DEFAULT_CATEGORY_DESCRIPTION,
  DEFAULT_CATEGORY_THUMBNAIL,
  HELPDESK_LINK,
} from 'app/DocumentCollectionPage/constants'
import useCategories from 'app/DocumentCollectionPage/hooks/useCategories'
import CategoryError from 'app/DocumentCollectionPage/components/CategoryError'
import CategoryListItem from 'app/DocumentCollectionPage/components/CategoryListItem'
import DocumentEmptyState from 'app/DocumentCollectionPage/components/DocumentEmptyState'
import {
  CategoryListPreloader,
  CategoryListItemPreloader,
} from 'app/DocumentCollectionPage/components/Preloader'
import { useSETrackEvent } from '../hooks/useSETrackEvent'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

const LandingPage = () => {
  const { SETrackDocumentLandingPage } = useSETrackEvent()
  const [, setValue] = useLocalStorage('categoryLvl', null)
  const {
    fetchNextPage,
    hasCategoriesData,
    hasNextPage,
    isLoading,
    isSuccess,
    categoriesData,
    categoriesMeta,
    lastPageNumber,
    refetch,
  } = useCategories()

  const retryHandler = () => {
    refetch({ refetchPage: (page, index) => index === lastPageNumber })
  }

  useEffect(() => {
    setValue(0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className="max-w-xl mx-auto">
        <Header
          showHelpButton
          headerRightOnClick={() =>
            SETrackDocumentLandingPage('CLICK_HELP_KUMPULAN_DOKUMEN', {
              screen_name: 'KUMPULAN_DOKUMEN_LANDING_PAGE',
              event_trigger: 'KUMPULAN_DOKUMEN_LANDING_PAGE',
              url: HELPDESK_LINK,
            })
          }
        />

        <main className="mt-16">
          <TitleSection
            title={DEFAULT_CATEGORY_TITLE}
            description={DEFAULT_CATEGORY_DESCRIPTION}
            thumbnail={DEFAULT_CATEGORY_THUMBNAIL}
          />

          <section className="min-h-screen p-4 bg-default">
            {isLoading && <CategoryListPreloader />}

            {isSuccess && (
              <>
                {hasCategoriesData ? (
                  <InfiniteScroll
                    dataLength={categoriesData.length}
                    next={fetchNextPage}
                    hasMore={hasNextPage}
                    loader={
                      categoriesMeta?.isNextPageError ? (
                        <CategoryError onClick={retryHandler} />
                      ) : (
                        <CategoryListItemPreloader />
                      )
                    }
                    endMessage={
                      categoriesMeta?.isNextPageError ? (
                        <CategoryError onClick={retryHandler} />
                      ) : null
                    }
                  >
                    <ul className="pb-2 space-y-4">
                      {categoriesData.map((item, index) => (
                        <CategoryListItem
                          key={`category-${item?.id ?? index}`}
                          {...item}
                          onNextPage={() => setValue(1)}
                        />
                      ))}
                    </ul>
                  </InfiniteScroll>
                ) : (
                  <DocumentEmptyState />
                )}
              </>
            )}
          </section>
        </main>
      </div>
    </>
  )
}

export default LandingPage
